import { Box } from "@mui/material"
import './GGLoaderView.scss';
import loaderIcon from '../../../assets/images/loader/loaderIcon.png'

const GGLoaderView = () => {
  return (
    <Box className='gg-loader'>
        <span className="loader">
          <img src={loaderIcon} alt="loading icon" />
        </span>
    </Box>
  )
}

export default GGLoaderView